import React from "react";

interface Props {
  onClick: Function;
  title: string;
}

const TitleNav = ({ onClick, title }: Props) => {
  return (
    <div className="p-grid screen-title">
      <div className="p-col-12 p-md-6 p-lg-6 t-table">
        <div className="back-icon t-cell">
          <i
            className="fa fa-bx fa-arrow-circle-o-left cursor-pointer icon-fill-color"
            onClick={() => onClick()}
            aria-hidden="true"
          ></i>
        </div>
        <div className="title-text t-cell">{title}</div>
      </div>
    </div>
  );
};

export default TitleNav;
